class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.hideModal();
    document.body.classList.add('overflow-hidden');

    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  openCartModal() {
    this.hideModal();
    const exact = 0;
    const $this = this;

    this.notification.classList.add('animate');
    smoothScroll('cart-notification', 300, exact);

    this.notification.classList.add('active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    setTimeout(function(){
      document.body.classList.add('overflow-hidden');
      document.body.addEventListener('click', $this.onBodyClick);
    }, 400);
  }

  close() {
    this.notification.classList.remove('active');
    this.notification.classList.remove('animate');

    document.body.classList.remove('overflow-hidden');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderCartContent(response,upsell,addto = false) {
    const $this = this;
    const cart = new XMLHttpRequest();

    cart.onload = function() {

      $this.querySelector('.cart-notification-product').innerHTML =
        $this.getSectionInnerHTML(cart.responseText, '.js-contents');

      if ($this.header) $this.header.reveal();
      if (!addto) $this.openCartModal();
      $this.renderContents(response,upsell);
    };
    cart.open('GET', '/cart', true);
    cart.send();
  }

  renderContents(parsedState,upsell) {
      if (!upsell) {
        this.productId = parsedState.id;

        this.getSectionsToRender().forEach((section => {
          document.getElementById(section.id).style.flexFlow = 'row wrap';
          document.getElementById(section.id).innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        }));
      } else {
        const ids = parsedState.items.map((item) => item.id);

        this.getSectionsToRender().forEach((section => {
          if (section.id == 'cart-notification-product') {
            var template = '';

            ids.forEach((idd) => {
              this.productId = idd;
              template += '<div class="flexx sdfghj">' + this.getSectionInnerHTML(parsedState.sections[section.id], '#cart-notification-product-'+this.productId) + '</div>';
            });

            document.getElementById(section.id).innerHTML = template;

          } else {
            document.getElementById(section.id).innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
          }
        }));
      }

//       if (this.header) this.header.reveal();
//       this.open();
  }

  getSectionsToRender() {
    return [
/*      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-button'
      },*/
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  hideModal() {
//     document.body.classList.remove('overflow-hidden');
    document.querySelector('#QuickViewModal').removeAttribute('open');
    window.pauseAllMedia();
  }
}

customElements.define('cart-notification', CartNotification);
